import Spinners from "components/Shared/Spinners"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "reactstrap"
import {
  cancelInterview,
  getAvailableSlots,
  interviewApply,
} from "store/actions/jobApplicationAction"
import { showAlert } from "store/reducers/alertReducer"

const MyInterviews = () => {
  const { loading, availableSlots, isLoading } = useSelector(
    state => state.JobApplication
  )
  const navigate = useNavigate()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [selectedUuid, setSelectedUuid] = useState(null)
  const [selectedItem, setSelectedItem] = useState({})
  const [modal, setModal] = useState(false)

  useEffect(() => {
    getAllData()
  }, [])

  const getAllData = () => {
    dispatch(getAvailableSlots())
  }

  const handleAcceptReject = () => {
    const payload = {
      uuid: selectedUuid,
    }
    dispatch(interviewApply(payload))
      .then(action => {
        const { statusCode, success, message } = action?.payload
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }))
          setSelectedUuid(null)
          setModal(null)
          getAllData()
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
          setSelectedUuid(null)
        }
      })
      .catch(error => {})
  }

  const handleBookSlot = () => {
    console.log(selectedSlot)
    console.log(selectedUuid)
  }

  const toggle = () => setModal(!modal)

  const timeSlots = [
    { id: "1", label: "10:00 AM - 10:15 AM" },
    { id: "2", label: "10:15 AM - 10:30 AM" },
    { id: "3", label: "10:30 AM - 10:45 AM" },
    { id: "4", label: "10:45 AM - 11:00 AM" },
    { id: "5", label: "11:00 AM - 11:15 AM" },
    { id: "6", label: "11:15 AM - 11:30 AM" },
  ]

  const [selectedSlot, setSelectedSlot] = useState(null)

  const handleCancelInterview = uuid => {
    const payload = {
      uuid,
    }
    dispatch(cancelInterview(payload))
      .then(action => {
        const { statusCode, success, message } = action?.payload
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }))
          getAllData()
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
      })
      .catch(error => {})
  }

  return (
    <React.Fragment>
      <div className="page-content">
        {loading ? (
          <Spinners />
        ) : (
          <Container fluid>
            <Row>
              <Col xl="12">
                <h4 className="card-title mb-4">My Interviews Slots</h4>
                <Card className="user_personal_info">
                  <CardBody>
                    {loading && availableSlots.length === 0 ? (
                      <p>No data found</p>
                    ) : (
                      <Table className="table mb-0" hover>
                        <thead className="table-light full_th">
                          <tr>
                            <th>{t("S. No.")}</th>
                            <th>{t("Title")}</th>
                            <th>{t("Description")}</th>
                            <th>{t("Scheduled Date")}</th>
                            <th>{t("Scheduled Time")}</th>
                            <th>{t("Action")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {availableSlots?.map((item, index) => (
                            <tr key={index}>
                              <th scope="row">{index + 1}</th>
                              <td>{item?.title}</td>
                              <td>{item?.description || "-"}</td>
                              <td>{item?.start_date}</td>
                              <td>
                                {item?.start_time} ~ {item?.end_time}
                              </td>
                              <td>
                                <div className="d-flex gap-3">
                                  {item?.can_apply && (
                                    <Button
                                      color="success"
                                      onClick={() => {
                                        toggle()
                                        setSelectedUuid(item?.uuid)
                                        setSelectedItem(item)
                                        // handleAcceptReject(item?.uuid)
                                      }}
                                    >
                                      Book Your Time Slots
                                    </Button>
                                  )}
                                  {item?.is_cancelled ? (
                                    <p className="text-danger text-uppercase font-bold">
                                      {t("Cancelled")}
                                    </p>
                                  ) : (
                                    !item?.can_cancel &&
                                    !item?.can_apply && (
                                      <Button
                                        color="success"
                                        disabled={!item?.can_apply}
                                        onClick={() => {
                                          toggle()
                                          setSelectedUuid(item?.uuid)

                                          // handleAcceptReject(item?.uuid)
                                        }}
                                      >
                                        Book Your Time Slots
                                      </Button>
                                    )
                                  )}
                                  {item?.can_cancel && (
                                    <Button
                                      color="danger"
                                      onClick={() =>
                                        handleCancelInterview(item?.uuid)
                                      }
                                    >
                                      Cancel Slot
                                    </Button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        )}
      </div>
      <Modal isOpen={modal} toggle={toggle} size="md">
        <ModalHeader toggle={toggle}>Book Your Time Slots</ModalHeader>
        <ModalBody>
          <div className="row g-2">
            <h4>Are you sure you want to confirm this date and time slots</h4>
            <h5>Scheduled Date: {selectedItem?.start_date}</h5>
            <h5>
              Time: {selectedItem?.start_time} ~ {selectedItem?.end_time}
            </h5>
            {/* {timeSlots.map(slot => (
              <div className="col-4" key={slot.id}>
                <button
                  className={`btn btn-outline-primary w-100 py-2 ${
                    selectedSlot === slot.id ? "active" : ""
                  }`}
                  onClick={() => handleSelect(slot.id)}
                >
                  {slot.label}
                </button>
              </div>
            ))} */}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Close
          </Button>
          <Button color="primary" onClick={handleAcceptReject}>
            Book
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  )
}

export default MyInterviews
